import * as React from 'react';

import { Text } from '@lightspeed/flame/Text';
import { Tooltip } from '@lightspeed/flame/Tooltip';

import { createReactRenderer } from 'helpers/react-renderer';

import { IconHelp } from './utils';

type ItemType =
  | 'default'
  | 'non_inventory'
  | 'assembly'
  | 'box'
  | 'serialized'
  | 'serialized_assembly';

interface Props {
  itemType: ItemType;
  isMultiShop: boolean;
}

const TooltipReorderPointNeed: React.FC<Props> = ({ itemType, isMultiShop }) => {
  let formulaQty = ['in stock', 'on order for purchase orders'];
  if (itemType === 'box') {
    formulaQty = formulaQty.concat(['stock in boxes', 'back order boxes']);
  }
  if (isMultiShop) {
    formulaQty.push('incoming transfers');
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <Tooltip
        placement={window.history.getFilters().tab === 'reordering' ? 'bottom-end' : 'top'}
        // @ts-ignore
        content={
          <div style={{ width: 320 }}>
            <Text fontSize="12px" fontWeight="normal" lineHeight="1rem">
              The Re-Ordering calculation is determined by checking if the total of{' '}
              {formulaQty.map((formula, i) => (
                <React.Fragment key={formula}>
                  <b>{formula}</b>
                  {i < formulaQty.length - 2 ? `, ` : ''}
                  {i === formulaQty.length - 2 ? ` and ` : ''}
                </React.Fragment>
              ))}{' '}
              quantities is below or equal to the Reorder Point. If it is, the difference between
              the Desired Inventory Level and the total will be the <b>Need</b> quantity.
            </Text>
          </div>
        }
      >
        {IconHelp}
      </Tooltip>
    </div>
  );
};

const RenderedComponent = createReactRenderer({
  component: TooltipReorderPointNeed,
  selector: '[data-react-root="TooltipReorderPointNeed"]',
});

export default TooltipReorderPointNeed;

history.onChangeState(
  [
    {
      name: ['item.views.item'],
      form_name: 'view',
      tab: ['details', 'reordering'],
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
